import type { StepApprovalState } from "./phaseGates.api";

/**
 * D-211 / GAP-2 B: say on whom an unfinished step is waiting, so a step never
 * waits silently. The numbers come from the server (the approver set frozen at
 * submit). A step with no figures (a legacy request) gets no line at all:
 * "cannot tell" is never rendered as 0.
 *
 * #1577 ruling: an ALL step that a required approver can no longer decide can
 * never complete, so it shows no count, only why (D-99: say what is true).
 */
export function awaitingApproversText(
  step: Pick<
    StepApprovalState,
    | "status"
    | "possibleApprovers"
    | "awaitingApprovals"
    | "unavailableRequiredApprovers"
  >,
): string | null {
  if (step.status === "APPROVED" || step.status === "REJECTED") return null;
  const unavailable = step.unavailableRequiredApprovers;
  if (typeof unavailable === "number" && unavailable > 0) {
    return `Can't complete: ${unavailable} required ${
      unavailable === 1 ? "approver" : "approvers"
    } no longer available`;
  }
  const { possibleApprovers: possible, awaitingApprovals: awaiting } = step;
  if (typeof possible !== "number" || typeof awaiting !== "number") return null;
  if (possible === 0) return "No one can approve this step";
  return `Awaiting ${awaiting} of ${possible} possible ${
    possible === 1 ? "approver" : "approvers"
  }`;
}
